
import React, {useEffect} from "react";
import {Route, Switch, useLocation} from "react-router-dom";
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";

// core components
import RTLNavbar from "components/Navbars/RTLNavbar.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import FixedPlugin from "components/FixedPlugin/FixedPlugin.js";

import routes from "../../utils/routes";

import logo from "assets/img/dashboard.svg";
import {BackgroundColorContext} from "contexts/BackgroundColorContext";
import PrivateRoute from "../../utils/privateRoute";
import {setAuth} from "../../utils/store/Accounting/AccountingActions";
import {connect} from "react-redux";

var ps;

function RTL(props) {
    const location = useLocation();
    const mainPanelRef = React.useRef(null);
    const [sidebarOpened, setsidebarOpened] = React.useState(
        document.documentElement.className.indexOf("nav-open") !== -1
    );
    React.useEffect(() => {
        if (navigator.platform.indexOf("Win") > -1) {
            document.documentElement.className += " perfect-scrollbar-on";
            document.documentElement.classList.remove("perfect-scrollbar-off");
            ps = new PerfectScrollbar(mainPanelRef.current, {
                suppressScrollX: true,
            });
            let tables = document.querySelectorAll(".table-responsive");
            for (let i = 0; i < tables.length; i++) {
                ps = new PerfectScrollbar(tables[i]);
            }
        }
        // on this page, we need on the body tag the classes .rtl and .menu-on-right
        document.body.classList.add("rtl", "menu-on-right");
        // we also need the rtl bootstrap
        // so we add it dynamically to the head

        // Specify how to clean up after this effect:
        return function cleanup() {
            if (navigator.platform.indexOf("Win") > -1) {
                ps.destroy();
                document.documentElement.classList.add("perfect-scrollbar-off");
                document.documentElement.classList.remove("perfect-scrollbar-on");
            }
            // when we exit this page, we need to delete the classes .rtl and .menu-on-right
            // from the body tag
            document.body.classList.remove("rtl", "menu-on-right");
            // we also need to delete the rtl bootstrap, so it does not break the other pages
            // that do not make use of rtl
        };
    });
    React.useEffect(() => {
        if (navigator.platform.indexOf("Win") > -1) {
            let tables = document.querySelectorAll(".table-responsive");
            for (let i = 0; i < tables.length; i++) {
                ps = new PerfectScrollbar(tables[i]);
            }
        }
        document.documentElement.scrollTop = 0;
        document.scrollingElement.scrollTop = 0;
        if (mainPanelRef.current) {
            mainPanelRef.current.scrollTop = 0;
        }
    }, [location]);
    // this function opens and closes the sidebar on small devices
    const toggleSidebar = () => {
        document.documentElement.classList.toggle("nav-open");
        setsidebarOpened(!sidebarOpened);
    };

    function checkAuth() {
        var token = localStorage.getItem('accessToken')

        if (token !== null) {
            setAuth(true)
        }
    }
    checkAuth();

    const getRoutes = (routes, isPublic) => {
        return routes.map((prop, key) => {
            if (isPublic !== prop.public) {
                return (
                    <PrivateRoute path={prop.path}
                                  component={prop.component}
                                  key={key}
                                  exact={prop.exact}
                                  name={prop.name}
                                  auth={props.isAuthorize}
                    />
                );
            } else {
                return (
                    <Route
                        path={prop.path}
                        component={prop.component}
                        key={key}
                        exact={prop.exact}
                        name={prop.name}
                    />
                );
            }

        });
    };
    const getBrandText = (path) => {
        for (let i = 0; i < routes.length; i++) {
            if (path.indexOf(routes[i].path) !== -1) {
                return routes[i].name;
            }
        }
        return "Brand";
    };
    const urlpath = window.location.pathname
    const url = urlpath.split('/')[1]
    return (
        <>
            <BackgroundColorContext.Consumer>
                {({color, changeColor}) => {
                    if (url === 'admin') {
                        return (<React.Fragment>
                            <div className="wrapper">
                                <Sidebar
                                    routes={routes}
                                    rtlActive
                                    logo={{
                                        innerLink: "/admin/dashboard",
                                        text: "داشبورد",
                                        imgSrc: logo,
                                    }}
                                    toggleSidebar={toggleSidebar}
                                />
                                <div className="main-panel" ref={mainPanelRef} data={color}>
                                    <RTLNavbar
                                        brandText={getBrandText(location.pathname)}
                                        toggleSidebar={toggleSidebar}
                                        sidebarOpened={sidebarOpened}
                                    />
                                    <Switch>{getRoutes(routes.filter(r => r.public === false))}</Switch>
                                    {/*{*/}
                                    {/*  // we don't want the Footer to be rendered on map page*/}
                                    {/*  location.pathname === "/admin/maps" ? null : <Footer fluid />*/}
                                    {/*}*/}
                                </div>
                            </div>
                            {/*<FixedPlugin bgColor={color} handleBgClick={changeColor}/>*/}
                        </React.Fragment>)
                    } else {
                        return (
                            <div className="wrapper"
                                 ref={mainPanelRef}><Switch>{getRoutes(routes.filter(r => r.public === true), true)}
                            </Switch>
                            </div>)
                    }

                }}
            </BackgroundColorContext.Consumer>
        </>
    );
}

const MapStateToProps = (state) => {
    return {
        isAuthorize: state.handleAuth.isAuthorize,
    }
};

export default connect(MapStateToProps)(RTL)

